module.exports = __webpack_public_path__ + "img/jingpin-pc.fafa7a09.png";